import React, { useState, useEffect } from "react";
import "../App.css";
import { getTokenInternal } from "./useToken";
import { useNavigate } from "react-router";
import Nav from "./Navigation.js";
import { useLocation } from "react-router-dom";

const EditItemForm = () => {
  const { state } = useLocation();
  const [formData, setFormData] = useState({
    name: "",
    types: "",
    event: "",
    maps: "",
    maps_name: "",
    url: "",
  });

  const [token, setToken] = useState(null);
  const [typeOptions, setTypeOptions] = useState([]);
  const [eventOptions, setEventOptions] = useState([]);
  const [mapsNameOptions, setMapsNameOptions] = useState([]);
  const [mapsExclusiveOptions, setMapsExclusiveOptions] = useState([]);
  const [eventCreated, setEventCreated] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fetchedToken = await getTokenInternal();
        setToken(fetchedToken);

        if (
          !fetchedToken ||
          (fetchedToken.account.role !== "management" &&
            fetchedToken.account.role !== "owner")
        ) {
          navigate("/");
          return; // Stop execution if the user is not authorized
        }

        const typesOptionsResponse = await fetch(
          `${process.env.REACT_APP_API_HOST}/api/types`
        );
        const eventOptionsResponse = await fetch(
          `${process.env.REACT_APP_API_HOST}/api/events`
        );
        const mapsExclusiveOptionsResponse = await fetch(
          `${process.env.REACT_APP_API_HOST}/api/maps`
        );
        const mapsNameOptionsResponse = await fetch(
          `${process.env.REACT_APP_API_HOST}/api/maps_name`
        );

        const typesOptionsData = await typesOptionsResponse.json();
        const eventOptionsData = await eventOptionsResponse.json();
        const mapsExclusiveOptionsData =
          await mapsExclusiveOptionsResponse.json();
        const mapsNameOptionsData = await mapsNameOptionsResponse.json();

        setTypeOptions(typesOptionsData);
        setEventOptions(eventOptionsData);
        setMapsExclusiveOptions(mapsExclusiveOptionsData);
        setMapsNameOptions(mapsNameOptionsData);

        // Set the initial form data using the received item data
        if (state && state.itemData) {
          setFormData(state.itemData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [state, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (!token) {
        console.error("Token is not available.");
        return;
      }

      const response = await fetch(
        `${process.env.REACT_APP_API_HOST}/api/items/${state.itemData.id}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token.access_token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setEventCreated(true);
        // Set a timer to clear the message after 5 seconds
        setTimeout(() => {
          setEventCreated(false);
        }, 5000);
        // Optionally navigate away or provide feedback to the user
      } else {
        console.error("Failed to update item:", response.status);
        setEventCreated(false);
      }
    } catch (error) {
      console.error("Error:", error);
      setEventCreated(false);
    }
  };

  return (
    <div className="text-white">
      <Nav></Nav>
            {eventCreated && (
        <p className="text-green-500 text-center">Item Updated!</p>
      )}
      <form onSubmit={handleSubmit} className="max-w-md mx-auto my-8">
        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Name:
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            />
          </label>
        </div>

        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Category:
            <select
              name="types"
              value={formData.types}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            >
              <option value="" disabled>
                Select a type
              </option>
              {typeOptions.map((type) => (
                <option key={type.id} value={type.name}>
                  {type.name}
                </option>
              ))}
            </select>
          </label>
        </div>

        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Event:
            <select
              name="event"
              value={formData.event}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            >
              <option value="" disabled>
                Select an event
              </option>
              {eventOptions.map((event) => (
                <option key={event.id} value={event.name}>
                  {event.name}
                </option>
              ))}
            </select>
          </label>
        </div>

        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Stamp type or Maps Exclusive:
            <select
              name="maps"
              value={formData.maps}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            >
              <option value="" disabled>
                Select a maps exclusive
              </option>
              {mapsExclusiveOptions.map((mapsExclusive) => (
                <option key={mapsExclusive.id} value={mapsExclusive.name}>
                  {mapsExclusive.name}
                </option>
              ))}
            </select>
          </label>
        </div>

        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Maps Name:
            <select
              name="maps_name"
              value={formData.maps_name}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            >
              <option value="" disabled>
                Select a maps exclusive
              </option>
              {mapsNameOptions.map((mapsName) => (
                <option key={mapsName.id} value={mapsName.name}>
                  {mapsName.name}
                </option>
              ))}
            </select>
          </label>
        </div>

        <div className="mb-4">
          <label className="block text-white text-sm font-bold mb-2">
            Url:
            <input
              type="text"
              name="url"
              value={formData.url}
              onChange={handleChange}
              className="mt-1 p-2 w-full border text-black rounded-md"
            />
          </label>
        </div>

        <div className="text-center">
          <button
            type="submit"
            className="bg-blue-500 text-white p-2 rounded-md hover:bg-blue-700"
          >
            Update Item
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditItemForm;



// import React, { useState, useEffect } from "react";
// import "../App.css";
// import { getTokenInternal } from "./useToken";
// import { useNavigate } from "react-router";
// import Nav from "./Navigation.js";
// import { useLocation } from "react-router-dom";

// const EditItemForm = () => {
//   const { state } = useLocation();
//   const [formData, setFormData] = useState({
//     name: "",
//     types: "",
//     event: "",
//     maps: "",
//     maps_name: "",
//     url: "",
//   });

//   const [token, setToken] = useState(null);
//   const [typeOptions, setTypeOptions] = useState([]);
//   const [eventOptions, setEventOptions] = useState([]);
//   const [mapsNameOptions, setMapsNameOptions] = useState([]);
//   const [mapsExclusiveOptions, setMapsExclusiveOptions] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const fetchedToken = await getTokenInternal();
//         setToken(fetchedToken);

//         // Check user role and navigate
//         if (
//           !fetchedToken ||
//           (token.account.role !== "management" &&
//             token.account.role !== "owner")
//         ) {
//           navigate("/");
//         }

//         const typesOptionsResponse = await fetch(
//           `${process.env.REACT_APP_API_HOST}/api/types`
//         );
//         const eventOptionsResponse = await fetch(
//           `${process.env.REACT_APP_API_HOST}/api/events`
//         );
//         const mapsExclusiveOptionsResponse = await fetch(
//           `${process.env.REACT_APP_API_HOST}/api/maps`
//         );
//         const mapsNameOptionsResponse = await fetch(
//           `${process.env.REACT_APP_API_HOST}/api/maps_name`
//         );

//         const typesOptionsData = await typesOptionsResponse.json();
//         const eventOptionsData = await eventOptionsResponse.json();
//         const mapsExclusiveOptionsData =
//           await mapsExclusiveOptionsResponse.json();
//         const mapsNameOptionsData = await mapsNameOptionsResponse.json();

//         setTypeOptions(typesOptionsData);
//         setEventOptions(eventOptionsData);
//         setMapsExclusiveOptions(mapsExclusiveOptionsData);
//         setMapsNameOptions(mapsNameOptionsData);

//         // Set the initial form data using the received item data
//         setFormData(state.itemData);
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchData();
//   }, [state.itemData, navigate]);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       if (!token) {
//         console.error("Token is not available.");
//         return;
//       }

//       const response = await fetch(
//         `${process.env.REACT_APP_API_HOST}/api/items/${state.itemData.id}`,
//         {
//           method: "PUT",
//           headers: {
//             Authorization: `Bearer ${token.access_token}`,
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(formData),
//         }
//       );

//       if (response.ok) {
//         const data = await response.json();
//       } else {
//         console.error("Failed to update item:", response.status);
//       }
//     } catch (error) {
//       console.error("Error:", error);
//     }
//   };

//   return (
//     <div className="text-white">
//       <Nav></Nav>
//       <form onSubmit={handleSubmit} className="max-w-md mx-auto my-8">
//         <div className="mb-4">
//           <label className="block text-white text-sm font-bold mb-2">
//             Name:
//             <input
//               type="text"
//               name="name"
//               value={formData.name}
//               onChange={handleChange}
//               className="mt-1 p-2 w-full border text-black rounded-md"
//             />
//           </label>
//         </div>

//         <div className="mb-4">
//           <label className="block text-white text-sm font-bold mb-2">
//             Category:
//             <select
//               name="types"
//               value={formData.types}
//               onChange={handleChange}
//               className="mt-1 p-2 w-full border text-black rounded-md"
//             >
//               <option value="" disabled>
//                 Select a type
//               </option>
//               {typeOptions.map((type) => (
//                 <option key={type.id} value={type.name}>
//                   {type.name}
//                 </option>
//               ))}
//             </select>
//           </label>
//         </div>

//         <div className="mb-4">
//           <label className="block text-white text-sm font-bold mb-2">
//             Event:
//             <select
//               name="event"
//               value={formData.event}
//               onChange={handleChange}
//               className="mt-1 p-2 w-full border text-black rounded-md"
//             >
//               <option value="" disabled>
//                 Select an event
//               </option>
//               {eventOptions.map((event) => (
//                 <option key={event.id} value={event.name}>
//                   {event.name}
//                 </option>
//               ))}
//             </select>
//           </label>
//         </div>

//         <div className="mb-4">
//           <label className="block text-white text-sm font-bold mb-2">
//             Stamp type or Maps Exclusive:
//             <select
//               name="maps"
//               value={formData.maps}
//               onChange={handleChange}
//               className="mt-1 p-2 w-full border text-black rounded-md"
//             >
//               <option value="" disabled>
//                 Select a maps exclusive
//               </option>
//               {mapsExclusiveOptions.map((mapsExclusive) => (
//                 <option key={mapsExclusive.id} value={mapsExclusive.name}>
//                   {mapsExclusive.name}
//                 </option>
//               ))}
//             </select>
//           </label>
//         </div>

//         <div className="mb-4">
//           <label className="block text-white text-sm font-bold mb-2">
//             Maps Name:
//             <select
//               name="maps_name"
//               value={formData.maps_name}
//               onChange={handleChange}
//               className="mt-1 p-2 w-full border text-black rounded-md"
//             >
//               <option value="" disabled>
//                 Select a maps exclusive
//               </option>
//               {mapsNameOptions.map((mapsName) => (
//                 <option key={mapsName.id} value={mapsName.name}>
//                   {mapsName.name}
//                 </option>
//               ))}
//             </select>
//           </label>
//         </div>

//         <div className="mb-4">
//           <label className="block text-white text-sm font-bold mb-2">
//             Url:
//             <input
//               type="text"
//               name="url"
//               value={formData.url}
//               onChange={handleChange}
//               className="mt-1 p-2 w-full border text-black rounded-md"
//             />
//           </label>
//         </div>

//         <div className="text-center">
//           <button
//             type="submit"
//             className="bg-blue-500 text-white p-2 rounded-md hover:bg-blue-700"
//           >
//             Update Item
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default EditItemForm;
